// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__dFqQQ","head":"Table_head__1WRJY","col":"Table_col__1X95h"};